import { RFValue } from "react-native-responsive-fontsize";

export default {
  COLORS: {
    ALERT: "#9c0505",
    ICON: '#D39894', //COR DOS CADEADOS E DAS SETAS PARA O LADO
    ICON_HEADER_PURCHASE: "#1B4235", //COR DAS SETINHAS 
    BACKGROUND_HEADER: "none", //COR DE TODOS OS CABEÇALHOS

    //TELA CLICKCOURSE, PLANS e SIGNUP
    ICON_HEADER: "#1B4235",  //COR DA PALAVRA ESCOLHER COMPRA, CADASTRAR-SE E COMPLETAR PAGAMENTO

    //CORES GERAIS
    PRIMARY_900: "#D39894", //COR PRINCIPAL DOS DETALHES DO APP - CHECKBOX, FECHAR TERMOS DE USO, ETC
    PRIMARY_800: "#B1BAA7", //COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    PRIMARY_700: "#EAD8CC", //COR MAIS CLARA DO CLIENTE = COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    TEXT_BUTTON: "white", //USADA PARA O TEXTO DOS BOTÕES LOGIN, CLICKCOURSE, SIGNUP - COR DE FUNDO É A PRIMARY_900

    //CORES DO DRAWER
    DRAWER_SELECTED: "#D39894", //COR DRAWER CLICADO E DO TEXTO DO DRAWER

    //TELAS: LOGIN, CLICKCOURSE, SIGNUP E PLANS
    BACKGROUND_ABOUT: "#FFFFFF", //COR PARA A ABOUT, DRAWER, CLICK COURSE, PLANS, EDITPROFILE, LOGIN E CADASTRO
    TITLE_ABOUT: '#2e2e2e', //TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_ABOUT: '#1B4235', //TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //TELA TERMOS DE USO
    BACKGROUND_TERMS: "#FFFFFF", //COR PARA O FUNDO DOS TERMOS

    //TELA ABOUT - SECTION 5 - Plans
    S5_BACKGROUND: "#EAD8CC", //COR DE FUNDO DA SECTION 5
    S5_BACKGROUND_SELECTED: "#B1BAA7", //COR DE FUNDO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_BACKGROUND_NO_SELECTED: "#B1BAA7A0", //COR DE FUNDO DO ITEM NAO SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_SELECTED: "#1B4235", //COR DO TEXTO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_NO_SELECTED: "#EAD8CC", //COR DO TEXTO DO ITEM NAO SELECIONADO DA FLATLIST MENSAL, TRI, ETC

    //TELA MAIN
    ICON_HEADER_CLICKCLASS: "#1B4235", //COR DO ÍCONE VOLTAR DA CLICKCLASS
    ICON_HEADER_MAIN: "#1B4235", //COR DO ICONE DRAWER
    BACKGROUND_MAIN: "#EAD8CC", //COR PARA A MAIN E CLICKCLASS
    TITLE_OVERPHOTO_MAIN: "white", //USADA PARA O TÍTULO E SUBTÍTULO DA MAIN
    TITLE_MAIN: "#1B4235", //USADA PARA PARA OS TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_MAIN: "#1B4235", //USADA PARA PARA OS TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //FOOTER TELA ABOUT E DRAWER
    BACKGROUND_FOOTER: "#2e2e2e", //COR DO RODAPÉ
    TEXT_FOOTER: "#EAD8CC", //USADA PARA O TEXTO DO RODAPÉ

    GRADIENT_MAIN: [
      'rgba(255,255,255,0.9)',
      'rgba(255,255,255,0.1)',
      'rgba(0,0,0,0.1)',
      '#EAD8CC'
    ],

    //BOTÕES ARQUIVAR E PUBLICAR
    BACKGROUND_PUBLISH: "#1B4235", //COR DO RODAPÉ
    BACKGROUND_ARCHIVE: "#D39894", //COR DO RODA
    TEXT_PUBLISH: "#EAD8CC", //USADA PARA O TEXTO DO RODAPÉ
    TEXT_ARCHIVE: "#1B4235", //USADA PARA O TEXTO DO RODAPÉ
  },

  FONTFAMILY: {
    BOLD: "text_Bold",
    MEDIUM: "text_Medium",
    REGULAR: "text_Regular",
    LIGHT: "text_Light",
    TITLE: "text_Title",
    SUBTITLE: "text_Subtitle",
    TEXTS: "text_Texts"
  },
  FONTSIZE: {
    EXTRABIG: RFValue(30, 980), //USADA 1X NA COURSES
    BIG: 24,
    STANDARD: 20,
    MEDIUM: 18,
    SMALL: 16,
    EXTRASMALL: 13,
  },
};
